import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { LandDetailPage } from '~/components/Land/Detail/LandDetailPage';
import { LandEventPage } from '~/components/Land/Event/LandEventPage';
import { LandHistoryPage } from '~/components/Land/History/LandHistoryPage';
import { LandRedirect } from '~/components/Land/LandRedirect';
import { W8benOpener } from '~/components/Land/W8ben/W8benOpener';
export const LandRouteSwitch = ({ match: { path } }: RouteComponentProps) => (
  <Route>
    <W8benOpener />
    <Switch>
      <Route path={[path, `${path}/event`]} exact component={LandRedirect} />
      <Route path={`${path}/event/history`} exact component={LandHistoryPage} />
      <Route path={`${path}/event/:week`} exact component={LandEventPage} />
      <Route path={`${path}/event/:week/land/:landId`} exact component={LandDetailPage} />
      <Redirect to={path} />
    </Switch>
  </Route>
);
